import { render, staticRenderFns } from "./SftpParameters.vue?vue&type=template&id=1e6e9228&scoped=true"
import script from "./SftpParameters.vue?vue&type=script&lang=js"
export * from "./SftpParameters.vue?vue&type=script&lang=js"
import style0 from "./SftpParameters.vue?vue&type=style&index=0&id=1e6e9228&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6e9228",
  null
  
)

export default component.exports